// Locale-aware currency amount; the API sends prices as decimal strings.
export const formatPrice = (
  price: string | number | null,
  locale: string,
  currency = 'EUR'
): string => {
  if (price === null || price === '') return '';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(price));
};
